exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\nStylesheet for the page to list the existing business models of a user.\n@author Michael Frey, Andrea Villeda\n*/\n.mirror[data-v-a0a9f0fc] {\n    -webkit-transform: rotate(180deg) scaleX(-1);\n            transform: rotate(180deg) scaleX(-1);\n}\n.no-link[data-v-a0a9f0fc] {\n    text-decoration: none !important;\n}", "", {"version":3,"sources":["/home/gitlab-runner/builds/3bb37404/0/mkz/werner-frontend/src/components/company/businessmodel/load/bmload.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;IACI,6CAAqC;YAArC,qCAAqC;CACxC;AAED;IACI,iCAAiC;CACpC","file":"bmload.css","sourcesContent":["/*\nStylesheet for the page to list the existing business models of a user.\n@author Michael Frey, Andrea Villeda\n*/\n\n.mirror {\n    transform: rotate(180deg) scaleX(-1);\n}\n\n.no-link {\n    text-decoration: none !important; \n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0a9f0fc","scoped":true,"hasInlineConfig":false}!./src/components/company/businessmodel/load/bmload.css
// module id = bGRO
// module chunks = 1